module.exports = __webpack_public_path__ + "static/media/reactImg.2c2cd65c.png";